




































































































import Vue from 'vue'
import _ from 'lodash'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { Department } from '@/model/companyStructure/Department'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { Employee } from '@/model/companyStructure/Employee'
import { CompanyStructure } from '@/types'
import { CompanyFilterValue } from '@/types/payload'
import { AbsenceReason } from '@/model/absences/AbsenceReason'
import { LOAD_ABSENCE_REASON_LIST, SCHEDULING_SET_PARAMETERS } from '@/store/action-types'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import { SCHEDULING_GET_PARAMETERS } from '@/store/getter-types'

interface ComponentData {
  profitCenterList: Array<ProfitCenter>

  selectedProfitCenterId: number | undefined
  selectedDepartmentId: number | undefined
  selectedPlanningGroupId: number | undefined
  selectedEmployeeId: number | undefined
  absenceReasonList: Array<AbsenceReason>
  selectedAbsenceReasonId: number | undefined
  panel: number[]
}

export default Vue.extend({
  name: 'CompanyFilter',

  props: {
    companyStructure: {
      type: Object as () => CompanyStructure
    },

    selectedAbsenceTemplateName: String
  },

  data (): ComponentData {
    return {
      profitCenterList: [],
      selectedProfitCenterId: undefined,
      selectedDepartmentId: undefined,
      selectedPlanningGroupId: undefined,
      selectedEmployeeId: undefined,
      absenceReasonList: [],
      selectedAbsenceReasonId: undefined,
      panel: []
    }
  },

  computed: {
    departmentList (): Array<Department> {
      let list: Array<Department> = []

      if (this.selectedProfitCenterId) {
        list = this.companyStructure.departmentList
          .filter((item: Department) => item.profitCenterId === this.selectedProfitCenterId)
      }

      return list
    },

    planningGroupList (): Array<PlanningGroup> {
      let list: Array<PlanningGroup> = []

      if (this.selectedProfitCenterId && this.selectedDepartmentId) {
        list = this.companyStructure.planningGroupList
          .filter((item: PlanningGroup) => item.department === this.selectedDepartmentId)
      }

      return list
    },

    employeeList (): Array<Employee> {
      let list: Array<Employee> = []

      if (this.selectedProfitCenterId && this.selectedDepartmentId && this.selectedPlanningGroupId) {
        list = this.companyStructure.employeeList
          .filter((item: Employee) => item.planningGroupId === this.selectedPlanningGroupId)
      }

      return list
    },

    showAbsenceReason (): boolean {
      return securityService.isVisible(SecurityArea.Absences, SecurityComponent.ReasonForAbsence)
    },

    isDisabledAbsenceReason (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.ReasonForAbsence)
    }
  },

  watch: {
    companyStructure (newVal): void {
      this.profitCenterList = _.cloneDeep(newVal.profitCenterList)
      const userId = this.$store.state.currentUser.id
      if (newVal) {
        const user: Employee | undefined = this.companyStructure.employeeList.find((item: Employee) => userId === item.id)
        if (user) {
          let data: any = this.getRouteData()
          let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]

          let companyData: any | undefined = undefined
          if(data && data.companyData) {
            companyData = data.companyData
          } else if(schedulingData && schedulingData.data && schedulingData.data.companyData) {
            companyData = schedulingData.data.companyData
          }

          this.selectedProfitCenterId = companyData && companyData.selectedProfitCenterId && newVal.profitCenterList.find((item: ProfitCenter) => companyData.selectedProfitCenterId === item.id) ? companyData.selectedProfitCenterId : this.$store.state.currentUser.defaultProfitCenter ? newVal.profitCenterList.find((item: ProfitCenter) => this.$store.state.currentUser.defaultProfitCenter === item.id).id : newVal.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id).id
          this.selectedDepartmentId = companyData && companyData.selectedDepartmentId && newVal.departmentList.find((item: Department) => companyData.selectedDepartmentId === item.id) ? companyData.selectedDepartmentId : this.$store.state.currentUser.defaultDepartment ? newVal.departmentList.find((item: Department) => this.$store.state.currentUser.defaultDepartment === item.id).id : newVal.departmentList.find((item: Department) => user.department === item.id).id
          this.selectedAbsenceReasonId = this.showAbsenceReason && companyData && companyData.selectedAbsenceReasonId ? companyData.selectedAbsenceReasonId : undefined
          this.filterValueChange()
        }
      }
    },

    selectedAbsenceTemplateName (newValue: string): void {
      if (newValue) {
        const foundAbsenceReason: AbsenceReason | undefined = this.absenceReasonList.find((item: AbsenceReason) => item.description === newValue)
        if (foundAbsenceReason) {
          this.selectedAbsenceReasonId = foundAbsenceReason.id
          this.onReasonSelect(foundAbsenceReason.id)
        }
      }
    },
  },

  methods: {
    onProfitCenterChange (): void {
      this.selectedDepartmentId = undefined
      if(this.departmentList.length > 0) {
        this.selectedDepartmentId = this.departmentList[0].id
      }
      this.filterValueChange()
    },

    onDepartmentChange (): void {
      this.filterValueChange()
    },

    async filterValueChange (): Promise<void> {
      const filterValue: CompanyFilterValue = {
        profitCenter: _.find(this.companyStructure.profitCenterList, { id: this.selectedProfitCenterId }),
        department: _.find(this.companyStructure.departmentList, { id: this.selectedDepartmentId }),
        planningGroup: _.find(this.companyStructure.planningGroupList, { planningGroup: this.selectedPlanningGroupId }),
        employee: _.find(this.companyStructure.employeeList, { id: this.selectedEmployeeId })
      }
      this.$emit('valueChanged', filterValue)

      if (this.selectedProfitCenterId) {
        const data: Array<AbsenceReason> = await this.$store.dispatch(LOAD_ABSENCE_REASON_LIST)

        this.absenceReasonList = _.sortBy(data, [function(o) { return o.description.toLocaleLowerCase(); }])
      }

      let routeData: any = this.getRouteData()
      this.selectedAbsenceReasonId = this.showAbsenceReason && routeData && routeData.companyData && routeData.companyData.selectedAbsenceReasonId && this.absenceReasonList.find((item: AbsenceReason) => routeData.companyData.selectedAbsenceReasonId === item.id) ? routeData.companyData.selectedAbsenceReasonId : undefined
      if(this.showAbsenceReason && this.selectedAbsenceReasonId) {
        this.onReasonSelect(this.selectedAbsenceReasonId)
      }
      routeData.companyData = {
        selectedProfitCenterId: this.selectedProfitCenterId,
        selectedDepartmentId: this.selectedDepartmentId,
        selectedAbsenceReasonId: this.selectedAbsenceReasonId
      }
      this.$router.push({ name: 'absences', query: { data: JSON.stringify(routeData) } })

      let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
      schedulingData.companyData = routeData.companyData
      this.$store.dispatch(SCHEDULING_SET_PARAMETERS, schedulingData)
    },

    onReasonSelect (reasonId: number): void {
      const reasonItem: AbsenceReason = _.find(this.absenceReasonList, { id: reasonId })! as AbsenceReason

      this.$emit('absenceReasonSelect', reasonItem)

      let data: any = this.getRouteData()
      data.companyData.selectedAbsenceReasonId = this.selectedAbsenceReasonId
      this.$router.push({ name: 'absences', query: { data: JSON.stringify(data) } })
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    }
  }

})
